function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapMutations } from 'vuex';
import analytics_audience_service from '@/apps/audiences/services/analytics_audience_service';
import module_dashboard_service from '@/apps/data-platform/services/reports/module_dashboard_service';
import { LIST_ROLES, LIST_DOMAINS, ROLES_LIST } from '@/js/constants';
import tasks from '@/js/tasks';

/*
|---------------------------------------------------------------------
| Board Page
|---------------------------------------------------------------------
|
| Kanban board page component with the logic to display and manage
| cards
|
*/
export default _defineProperty({
  components: {},
  data: function data() {
    return {
      inframeHeight: 100,
      key_iframe: 1,
      url_report: '',
      loadingReport: true,
      title: 'Reporte de Calidad de Atributos - Consistencia',
      description: 'Pagina de administracion del reporte.',
      id: 'attribute-quality-consistency',
      module: 'marketplace-atributos',
      dashboardUrl: '',
      showDashboard: false,
      report: null,
      maintenance: false,
      tienePermiso: false
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('data-platform', ['companyCode', 'orgs'])), {}, {
    getOrgs: function getOrgs() {
      var _orgs = [{
        value: null,
        text: '.: Selecciones un registro :.'
      }];
      this.orgs.forEach(function (x) {
        _orgs.push({
          value: x.code,
          text: x.domain
        });
      });
      return _orgs;
    },
    isAudienceAdmin: function isAudienceAdmin() {
      return window.userInfo.userRoles.includes(ROLES_LIST.AUDIENCE_ADMIN);
    }
  }),
  watch: {
    cards: function cards(val) {
      return this.parse(val);
    }
  },
  created: function created() {
    if (window.userInfo.userRoles.includes(ROLES_LIST.AUDIENCE_ADMIN)) {
      this.isAdmin = true;
    }
    this.getReport();
  },
  mounted: function mounted() {
    this.inframeHeight = window.innerHeight - 200;
    console.log(this.inframeHeight);
    this.key_iframe += 1;
  },
  methods: {
    traductor: function traductor(key) {
      return this.$i18n.t(key);
    },
    onEnableFilter: function onEnableFilter() {
      this.filter_enabled = !this.filter_enabled;
    },
    loadedIframe: function loadedIframe() {},
    onRecargarReporte: function onRecargarReporte() {
      this.getReport();
      this.key_iframe += 1;
    },
    getReport: function getReport() {
      var _this = this;
      var request = {
        module: this.module,
        id: this.id
      };
      module_dashboard_service.getReport(request).then(function (response) {
        if (response.data) {
          _this.report = response.data;
          _this.dashboardUrl = _this.report.link;
          _this.maintenance = _this.report.maintenance;
          if (!_this.report.all_permission) {
            _this.report.organizations.forEach(function (element) {
              if (element.id === _this.companyCode) {
                _this.tienePermiso = true;
              }
            });
          } else {
            _this.tienePermiso = true;
          }
        } else {
          _this.maintenance = true;
        }
      });
    },
    onCopyCode: function onCopyCode() {
      navigator.clipboard.writeText(this.report.code);
      this.$toast.info(this.translate('frases.code_copied'));
      this.showDashboard = true;
    }
  }
}, "computed", _objectSpread(_objectSpread({}, mapState('data-platform', ['companyCode', 'companyName'])), {}, {
  getClassTable: function getClassTable() {
    return 'col-sm-12';
  }
}));